import React, { useEffect, useState } from "react";
import Icon from "../Icon/Icon";
import { InfiosButton } from "./Button.style";

const Button = (props) => {
  const {
    text,
    className,
    noIcon,
    partner,
    secondary,
    tertiary,
		blue,
    green,
    greenlight,
    white,
    disabled,
    animated,
    animatedVertically,
    inverted,
    floating,
    floatingAboveChat,
    onClick,
    onMouseEnter,
    onMouseLeave,
    icon,
    type,
    id,
    fullWidthOnMobileAndTablet,
    hasCustomTransition,
  } = props;

  const createClassName = () => {
        const keys = { partner, secondary, tertiary, blue, green, greenlight, white, disabled, animated, inverted };
        const trueKeys = Object.keys(keys).filter(key => keys[key] === true);



    return trueKeys.join(" ");
  };

  return (
    <InfiosButton
      data-analytics="button"
      noIcon={noIcon}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      animatedVertically={animatedVertically}
      partner={partner}
      secondary={secondary}
      tertiary={tertiary}
      inverted={inverted}
      floating={floating}
      floatingAboveChat={floatingAboveChat}
      type={type || "button"}
      disabled={disabled}
            className={`${createClassName()} ${className}`}
      id={id}
      fullWidthOnMobileAndTablet={fullWidthOnMobileAndTablet}
    >
      {text}
      {!noIcon && (
        <Icon
          animated={animated}
          animatedVertically={animatedVertically}
          icon={icon || "download"}
          hasCustomTransition={hasCustomTransition}
        />
      )}
    </InfiosButton>
  );
};

export default Button;
